import {
  getApiV1ThreeLetterCodeClientAdminsBranches,
  getGetApiV1ThreeLetterCodeClientAdminsBranchesKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  threeLetterCode: string;
};

/**
 * 事業所一覧取得フック
 *
 * @param threeLetterCode - 企業コード
 */
export const useGetClientBranches = ({ threeLetterCode }: Args) => {
  const { data } = useFetch(
    getGetApiV1ThreeLetterCodeClientAdminsBranchesKey(threeLetterCode),
    () => getApiV1ThreeLetterCodeClientAdminsBranches(threeLetterCode),
    { suspense: true }
  );

  return { data };
};
